import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Logo } from "@/components/Logo";

const inflight = new Map();
const storeKey = (k) => `landin-apply-${k}`;

const start = (key) => {
  if (!inflight.has(key)) {
    inflight.set(key, api.post(`/public/apply/${key}`).then((r) => {
      localStorage.setItem(storeKey(key), r.data.token);
      return r.data.token;
    }).finally(() => setTimeout(() => inflight.delete(key), 0)));
  }
  return inflight.get(key);
};

export default function ApplyStart() {
  const { propertyKey } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem(storeKey(propertyKey));
    if (saved) {
      navigate(`/a/${saved}`, { replace: true });
      return;
    }
    start(propertyKey).then((t) => navigate(`/a/${t}`, { replace: true })).catch((err) => setError(errorText(err)));
  }, [propertyKey, navigate]);

  return (
    <div className="min-h-screen bg-panel text-foreground">
      <header className="border-b bg-background">
        <div className="mx-auto flex h-14 max-w-md items-center px-5"><Logo /></div>
      </header>
      <main className="mx-auto max-w-md px-5 pb-16 pt-8">
        {error ? (
          <p className="rounded-xl bg-destructive/10 p-4 text-destructive" data-testid="apply-start-error">{error}</p>
        ) : (
          <p className="flex items-center gap-2 text-base text-muted-foreground" data-testid="apply-start-loading">
            <Loader2 className="size-5 animate-spin" /> Opening your application…
          </p>
        )}
      </main>
    </div>
  );
}
